import { cn } from "@/lib/utils";

const TONES: Record<string, string> = {
  ok: "bg-emerald-400", up: "bg-emerald-400", active: "bg-emerald-400",
  healthy: "bg-emerald-400", done: "bg-emerald-400", converged: "bg-emerald-400",
  enabled: "bg-emerald-400", installed: "bg-emerald-400",
  degraded: "bg-amber-400", applying: "bg-amber-400", warning: "bg-amber-400",
  leased: "bg-amber-400", running: "bg-amber-400", draft: "bg-amber-400",
  detect: "bg-amber-400", queued: "bg-sky-400", verifying: "bg-sky-400",
  down: "bg-red-400", failed: "bg-red-400", error: "bg-red-400",
  gone: "bg-zinc-500",
};

export function StatusDot({ status, pulse, className }: {
  status: string; pulse?: boolean; className?: string;
}) {
  return (
    <span className={cn("inline-block h-2 w-2 rounded-full",
      TONES[status] ?? "bg-zinc-500",
      pulse && "animate-pulse-dot", className)} />
  );
}
